import { render } from "./ManualsList.vue?vue&type=template&id=4f1801e1&scoped=true"
import script from "./ManualsList.vue?vue&type=script&lang=js"
export * from "./ManualsList.vue?vue&type=script&lang=js"

import "./ManualsList.vue?vue&type=style&index=0&id=4f1801e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1801e1"],['__file',"src/views/ManualsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f1801e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f1801e1', __exports__)) {
    api.reload('4f1801e1', __exports__)
  }
  
  module.hot.accept("./ManualsList.vue?vue&type=template&id=4f1801e1&scoped=true", () => {
    api.rerender('4f1801e1', render)
  })

}


export default __exports__